module.exports = __webpack_public_path__ + "img/house1b.b57b02ec.jpg";